import React from 'react';
import getSeoData, { addJavaHeaders, getCity } from '../../utils';
import Dosier from './Dosier';
import Layout from '../../components/Layout';
import NotFound from '../not-found/NotFound';
import { setCity } from '../../actions/city';
import { checkStatus, getCityConfig, parseJSON } from '../../apiUtils';
import {
	startFetchingDosiersData,
	setDosiersData,
	fetchingDosiersDataError,
	getSortingDirectionDosiers,
	sortingTypeDosiers,
	sortingDirectionDosiers,
} from '../../actions/dosier';
import history from '../../history';

async function action({ fetch, pathname: path, params, store, query }) {
	const {
		token: { token },
		cities,
		cityConfig,
		dosier: {
			dosiersData: { items },
		},
	} = store.getState();

	const checkedCity = getCity(params.city, cities);

	if (!checkedCity)
		return {
			chunks: ['not-found'],
			title: 'Страница не найдена',
			component: (
				<Layout isNotFound>
					<NotFound title={this.title} />
				</Layout>
			),
			status: 404,
		};

	const city = setCity({
		store,
		params,
		fetch,
	});

	if (!cityConfig) {
		await getCityConfig(city.cityIds, {
			store,
			fetch,
		});
	}

	const { title, description, keywords } = await getSeoData(fetch, path, null, city.cityIds);

	if (items?.length === 0) {
		store.dispatch(startFetchingDosiersData());
		const fetchOptions = {
			method: 'POST',
			...addJavaHeaders(token),
			body: JSON.stringify({
				cityIds: city.cityIds,
				page: query?.page ? query.page - 1 : 0,
				sort: query?.sort ?? null,
			}),
		};
		const dosierUrl = '/lexsApi/developer/list';

		try {
			await fetch(dosierUrl, fetchOptions)
				.then(checkStatus)
				.then(parseJSON)
				.then((results) => {
					const { data } = results;
					store.dispatch(setDosiersData(data));

					if (data?.items <= 0 && data?.meta?.pageCount < query.page) {
						history.replace({
							search: `?page=${data.meta.pageCount}${query?.sort ? `&sort=${query.sort}` : ''}`,
						});
					}

					if (query?.sort) {
						const sortDirection = getSortingDirectionDosiers(query.sort);
						const sortType = sortDirection === 'down' ? query.sort.substring(1) : query.sort;
						store.dispatch(sortingTypeDosiers(sortType));
						store.dispatch(sortingDirectionDosiers(sortDirection));
					}
				});
		} catch (error) {
			store.dispatch(fetchingDosiersDataError());

			return {
				chunks: ['not-found'],
				title: 'Страница не найдена',
				component: (
					<Layout isNotFound>
						<NotFound />
					</Layout>
				),
				status: 404,
			};
		}
	}

	return {
		chunks: ['dosier'],
		title,
		description,
		keywords,
		component: (
			<Layout route="dosier">
				<Dosier />
			</Layout>
		),
	};
}

export default action;
